import styled from 'styled-components';
import { rem } from 'polished';

const ProductItemDiscountedPriceLabel = styled.span`
    padding-left: ${rem(8)};
    text-decoration: line-through;
`;

export default ProductItemDiscountedPriceLabel;
